import { cva } from "./index.ts";

export const input = cva({
  base: "flex w-full px-3 py-2 focus-visible:outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 data-[disabled]:bg-obsidian-50",
  variants: {
    variant: {
      default:
        "border border-input data-[error]:border-bittersweet-600 data-[focus]:!border-input focus:!border-input bg-background ring-offset-background data-[focus]:ring-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[focus]:ring-ring data-[focus]:ring-offset-2",
      fill: "bg-accent data-[focus]:ring-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[focus]:ring-ring data-[focus]:ring-offset-2",
      ghost:
        "bg-transparent border-b border-b-gray-300 !rounded-none px-2 focus-visible:border-hazel-600",
      inline:
        "inline-block -mx-3 bg-transparent hover:bg-obsidian-100 focus-visible:bg-obsidian-100 focus-visible:border-hazel-600 [&~.chevron]:opacity-0 [&~.chevron]:hover:opacity-100 [&~.chevron]:focus-visible:opacity-100 [&~.chevron]:transition-opacity [&~.chevron]:mr-2 transition-colors data-[focus]:ring-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[focus]:ring-ring data-[focus]:ring-offset-2",
    },
    size: {
      default: "h-8 md:h-9 rounded-md text-sm lg:text-base",
      sm: "h-8 rounded-md text-sm",
      lg: "h-10 rounded-lg text-lg",
    },
    type: {
      default: "",
      select: "pr-8",
    },
  },
  compoundVariants: [
    {
      size: "sm",
      variant: "inline",
      class: "h-auto rounded-sm px-2 py-1 -my-1 -mx-2",
    },
    {
      type: "select",
      variant: "inline",
      class: "pr-3",
    },
  ],
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});
